// extracted by mini-css-extract-plugin
export default {"container":"Daa-z","productName":"Eaa-z","price":"Faa-z","dimensions":"Gaa-z"};